/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="13.83"
        height="18.78"
        viewBox="0 0 13.83 18.78"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M12.28 4.8a4.16 4.16 0 0 0-2.89-.66 2.83 2.83 0 0 0-2.16 2 7.34 7.34 0 0 0-.13 2.64l.05.4a13.71 13.71 0 0 1 .13 3.2c-.06.61-.14 1.14-.21 1.6a13.17 13.17 0 0 0-.21 2.35 2.34 2.34 0 0 0 2.06 2.43 2.59 2.59 0 0 0 .48 0 2.3 2.3 0 0 0 2-1.26 13.87 13.87 0 0 0 1.24-4.36 15.37 15.37 0 0 1 .58-2.19 9.48 9.48 0 0 0 .52-2.3 4 4 0 0 0-1.48-3.87Zm-1.54 8.79-.12.1.66.75.11-.1a9.39 9.39 0 0 1-.84 2.68 1.27 1.27 0 0 1-1.46.74 1.38 1.38 0 0 1-.93-.47 1.39 1.39 0 0 1-.31-1 12.28 12.28 0 0 1 .2-2.18v-.16.05l.1.11.75-.65-.09-.12a3.21 3.21 0 0 1-.43-2.74 3.42 3.42 0 0 1 1.6-2l.24-.12.34.17a2.75 2.75 0 0 1 1.34 2 3.24 3.24 0 0 1-1.24 2.91Zm2-5a6.07 6.07 0 0 1-.12.84 4 4 0 0 0-1.43-1.63l-.37-.19v-.75l-1 .05v.72l-.23.12A4.69 4.69 0 0 0 8.19 9l-.05-.35a6.42 6.42 0 0 1 .09-2.23 1.82 1.82 0 0 1 1.39-1.3 3.15 3.15 0 0 1 2.13.49 3 3 0 0 1 1.06 3ZM6.63 4.92a7.56 7.56 0 0 0 .1-2.64 2.83 2.83 0 0 0-2-2.16 4.15 4.15 0 0 0-2.93.4A3.94 3.94 0 0 0-.01 4.25a9.29 9.29 0 0 0 .32 2.34 15.15 15.15 0 0 1 .38 2.22 13.84 13.84 0 0 0 .86 4.45 2.26 2.26 0 0 0 2.11 1.45 1.23 1.23 0 0 0 .27 0 2.33 2.33 0 0 0 2.26-2.21 13.4 13.4 0 0 0 0-2.37c0-.46-.07-1-.07-1.61a13.57 13.57 0 0 1 .41-3.17Zm-1.44 7.42a1.33 1.33 0 0 1-.4 1 1.35 1.35 0 0 1-1 .4 1.28 1.28 0 0 1-1.39-.88 9.16 9.16 0 0 1-.61-2.73l.1.1.72-.69-.1-.11a3.19 3.19 0 0 1-1-3A2.75 2.75 0 0 1 3.02 4.5l.36-.14a1.94 1.94 0 0 1 .24.15 3.46 3.46 0 0 1 1.42 2.1 3.26 3.26 0 0 1-.67 2.69l-.11.1.69.73.11-.1v.17a12.32 12.32 0 0 1 0 2.19Zm.44-7.64-.08.35a4.75 4.75 0 0 0-1.31-1.37l-.21-.13.1-.71-1-.14-.1.74-.39.16a3.94 3.94 0 0 0-1.62 1.49 8.27 8.27 0 0 1 0-.86 3 3 0 0 1 1.31-2.86 3.29 3.29 0 0 1 2.18-.3 1.83 1.83 0 0 1 1.26 1.41 6.38 6.38 0 0 1-.1 2.22Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'SandalsIcon';

export default Icon;
